import React from 'react';
import SEO from '../../common/SEO';
import Layout from '../../common/Layout';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { Table } from 'react-bootstrap';
import { GoFilePdf } from 'react-icons/all';
import { useLocation } from 'react-router-dom';
const TopTen = () => {
  const pdf = [
    'Afghanistan',
    'Bangladesh',
    'Bhutan',
    'India',
    'Maldives',
    'Nepal',
    'Pakistan',
    'Sri Lanka',
  ];
  const documents = {
    Afghanistan: [
      {
        link: 'Top Export Destinations',
        title: 'Top Export Destinations',
      },
      {
        link: 'Top Exports',
        title: 'Top Exports',
      },
      {
        link: 'Top Import Destinations',
        title: 'Top Import Destinations',
      },
      {
        link: 'Top Imports',
        title: 'Top Imports',
      },
      {
        'Data Source': 'ITC Trade Map',
      },
    ],
    Bangladesh: [
      {
        link: 'Top Export Destinations',
        title: 'Top Export Destinations',
      },
      {
        link: 'Top Exports',
        title: 'Top Exports',
      },
      {
        'Data Source': 'Export Promotion Bureau Bangladesh',
      },
    ],
    Bhutan: [
      {
        link: 'Top Export Destinations',
        title: 'Top Export Destinations',
      },
      { link: 'Top Exports', title: 'Top Exports' },
      { link: 'Top Import Destinations', title: 'Top Import Destinations' },
      {
        link: 'Top Imports',
        title: 'Top Imports',
      },
      {
        'Data Source':
          'Bhutan Trade Statistics, Department of Revenue and Customs, Ministry of Finance',
      },
    ],
    India: [
      {
        link: 'Top Export Destinations',
      },
      {
        link: 'Top Exports',
      },
      {
        link: 'Top Import Destinations',
      },
      {
        link: 'Top Imports',
      },
      { 'Data Source': 'ITC Trade Map' },
    ],
    Maldives: [
      {
        link: 'Top Export Destinations',
      },
      {
        link: 'Top Exports',
      },
      {
        link: 'Top Import Destinations',
      },
      {
        link: 'Top Imports',
      },
      {
        'Data Source': 'ITC Trade Map',
      },
    ],

    Nepal: [
      {
        link: 'Top Export Destinations',
      },
      {
        link: 'Top Exports',
      },
      {
        link: 'Top Import Destinations',
      },
      {
        link: 'Top Imports',
      },
      { 'Data Source': 'ITC Trade Map' },
    ],
    Pakistan: [
      {
        link: 'Top Export Destinations',
      },
      {
        link: 'Top Exports',
      },
      {
        link: 'Top Import Destinations',
      },
      {
        link: 'Top Imports',
      },
      { 'Data Source': 'ITC Trade Map' },
    ],
    'Sri Lanka': [
      {
        link: 'Top Export Destinations',
      },
      {
        link: 'Top Exports',
      },
      {
        link: 'Top Import Destinations',
      },
      {
        link: 'Top Imports',
      },
      { 'Data Source': 'Central Bank of Sri Lanka' },
    ],
  };
  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();
  return (
    <>
      <SEO title="Top 10s" />
      <Layout>
        <div className="main-content">
          {/* Start Contact Area  */}
          <div className="rwt-contact-area mt--30 mb-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <Tabs defaultIndex={query.get('t') ? query.get('t') : 0}>
                    <div className="row row--30 align-items-center">
                      <div className="col-lg-12 mt_md--40 mt_sm--40">
                        <div className="rn-default-tab">
                          <div className="tab-button-panel">
                            <TabList className="tab-button react-tabs__tab">
                              {pdf.map((item, index) => {
                                return (
                                  <Tab key={index}>
                                    <div className="rn-tab-button">
                                      <button>{item}</button>
                                    </div>
                                  </Tab>
                                );
                              })}
                            </TabList>
                          </div>

                          <div className="tab-content-panel">
                            {pdf.map((name, index) => {
                              return (
                                <TabPanel key={index}>
                                  <div className="rn-tab-content">
                                    <div className="inner">
                                      <div className="col-lg-12">
                                        <div className="rn-contact-address mt_dec--30">
                                          <Table striped bordered hover>
                                            <tbody>
                                              {Object.keys(documents).map((item) => {
                                                if (item !== name) return;
                                                return documents[item].map((elem) => {
                                                  return (
                                                    <>
                                                      {elem.link ? (
                                                        <tr>
                                                          <td>
                                                            <a
                                                              rel="noreferrer"
                                                              href={
                                                                '../../../documents/Top 10s/' +
                                                                name +
                                                                '/' +
                                                                elem.link +
                                                                '.pdf'
                                                              }
                                                              target="_blank"
                                                              className="color-black"
                                                            >
                                                              {elem.link}
                                                            </a>
                                                          </td>
                                                          <td>
                                                            <a
                                                              href={
                                                                '../../../documents/Top 10s/' +
                                                                name +
                                                                '/' +
                                                                elem.link +
                                                                '.pdf'
                                                              }
                                                              target="_blank"
                                                            >
                                                              <GoFilePdf color="red" size={20} />
                                                            </a>
                                                          </td>
                                                        </tr>
                                                      ) : (
                                                        <tr>
                                                          <td>
                                                            <b>
                                                              {'Data Source: ' +
                                                                elem['Data Source']}
                                                            </b>
                                                          </td>
                                                          <td></td>
                                                        </tr>
                                                      )}
                                                    </>
                                                  );
                                                });
                                              })}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </TabPanel>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
          {/* End Contact Area  */}
        </div>
      </Layout>
    </>
  );
};
export default TopTen;
